import { render, staticRenderFns } from "./FrequentItem.vue?vue&type=template&id=a4358afc"
import script from "./FrequentItem.vue?vue&type=script&lang=js"
export * from "./FrequentItem.vue?vue&type=script&lang=js"
import style0 from "./FrequentItem.vue?vue&type=style&index=0&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports